import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import s from './Financeiro.module.css';

// Cadastros auxiliares do MDF-e (Manifesto Eletrônico de Documentos Fiscais)
// — Veículos, Condutores e Proprietários de Veículo. Etapa 2 do módulo
// MDF-e: só cadastro por enquanto, a montagem do manifesto em si (escolher
// NF-e, veículo, condutor e transmitir) vem na Etapa 3, dentro do Módulo
// Fiscal. Mesmo padrão visual/estrutural de GruposMarcas.jsx (split-panel
// lista + formulário), adaptado pra formulários com mais campos.

const UFS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA',
  'PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

const TIPOS_RODADO = [
  { v: '01', l: 'Truck' }, { v: '02', l: 'Toco' }, { v: '03', l: 'Cavalo Mecânico' },
  { v: '04', l: 'VAN' }, { v: '05', l: 'Utilitário' }, { v: '06', l: 'Outros' },
];
const TIPOS_CARROCERIA = [
  { v: '00', l: 'Não aplicável' }, { v: '01', l: 'Aberta' }, { v: '02', l: 'Fechada/Baú' },
  { v: '03', l: 'Graneleira' }, { v: '04', l: 'Porta Container' }, { v: '05', l: 'Sider' },
];
// Domínio real do <tpProp> do MDF-e (mdfeModalRodoviario_v3.00.xsd):
// 0-TAC Agregado | 1-TAC Independente | 2-Outros.
const TIPOS_PROPRIETARIO = [
  { v: 'tac_agregado', l: 'TAC Agregado' },
  { v: 'tac_independente', l: 'TAC Independente' },
  { v: 'outros', l: 'Outros' },
];

function formatarCpfCnpj(v) {
  const d = (v || '').replace(/\D/g, '');
  if (d.length <= 11) return d.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, (_, a,b,c,e) => [a,b,c].filter(Boolean).join('.') + (e ? `-${e}` : ''));
  return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, (_, a,b,c,e,f) => `${a}.${b}.${c}/${e}${f ? `-${f}` : ''}`);
}

// ── Veículos ─────────────────────────────────────────────────────────────
function AbaVeiculos() {
  const vazio = { placa: '', renavam: '', tara_kg: '', capacidade_kg: '', capacidade_m3: '',
    tipo_rodado: '01', tipo_carroceria: '01', uf_licenciamento: '', proprietario_id: '', eh_reboque: false, ativo: true,
    codigo_interno: '' };
  const [lista, setLista]   = useState([]);
  const [proprietarios, setProprietarios] = useState([]);
  const [sel, setSel]       = useState(null);
  const [form, setForm]     = useState(vazio);
  const [modo, setModo]     = useState('lista');
  const [busca, setBusca]   = useState('');
  const [salvando, setSalvando] = useState(false);
  const [excluindo, setExcluindo] = useState(false);
  const [erro, setErro]     = useState('');
  const [sucesso, setSucesso] = useState('');

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get('/fiscal/veiculos', { params: { busca: busca || undefined, incluirInativos: true } });
      setLista(data || []);
    } catch { setErro('Erro ao carregar veículos.'); }
  }, [busca]);

  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => { api.get('/fiscal/proprietarios-veiculo').then(r => setProprietarios(r.data || [])).catch(() => {}); }, [modo]);

  const novo = () => { setForm(vazio); setSel(null); setErro(''); setSucesso(''); setModo('novo'); };
  const editar = (item) => {
    setForm({ ...vazio, ...item, proprietario_id: item.proprietario_id || '' });
    setSel(item); setErro(''); setSucesso(''); setModo('editar');
  };
  const cancelar = () => { setModo('lista'); setSel(null); setErro(''); };

  const salvar = async () => {
    if (!form.placa.trim()) { setErro('Placa é obrigatória.'); return; }
    if (!form.uf_licenciamento) { setErro('UF de licenciamento é obrigatória.'); return; }
    setErro(''); setSalvando(true);
    try {
      const payload = { ...form, proprietario_id: form.proprietario_id || null };
      if (modo === 'novo') await api.post('/fiscal/veiculos', payload);
      else await api.put(`/fiscal/veiculos/${sel.id}`, payload);
      setSucesso('Salvo com sucesso!');
      setTimeout(() => setSucesso(''), 2000);
      await carregar();
      setModo('lista');
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar.');
    } finally { setSalvando(false); }
  };

  const excluir = async () => {
    if (!sel) return;
    if (!window.confirm(`Excluir o veículo placa ${sel.placa}?`)) return;
    setErro(''); setExcluindo(true);
    try {
      const { data } = await api.delete(`/fiscal/veiculos/${sel.id}`);
      if (data.inativado) setSucesso('Veículo já usado em algum MDF-e — foi inativado em vez de excluído.');
      await carregar();
      setModo('lista'); setSel(null);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao excluir.');
    } finally { setExcluindo(false); }
  };

  return (
    <div>
      <div className={s.toolbar}>
        <button className={s.btnErpPrimario} onClick={novo}>+ Veículo</button>
        <input className={s.input} placeholder="Buscar por placa..."
          value={busca} onChange={e => setBusca(e.target.value)} style={{ maxWidth: 220 }} />
      </div>

      {erro    && <div className={s.erroMsg}>{erro}</div>}
      {sucesso && <div className={s.sucessoMsg}>{sucesso}</div>}

      <div className={s.conteudoSplit}>
        <div className={`${s.painel} ${s.painelLeft}`}>
          <div className={s.painelScroll}>
            {lista.length === 0
              ? <div style={{ padding: 16, color: '#888', fontSize: 12 }}>Nenhum veículo cadastrado.</div>
              : lista.map(item => (
                <div key={item.id}
                  className={`${s.listaItem} ${sel?.id === item.id ? s.listaItemSel : ''}`}
                  onClick={() => editar(item)} style={{ opacity: item.ativo === false ? 0.5 : 1 }}>
                  <div style={{ fontWeight: 'bold' }}>
                    {item.codigo_interno ? `#${item.codigo_interno} — ` : ''}{item.placa} {item.eh_reboque ? '(reboque)' : ''}
                  </div>
                  <div style={{ fontSize: 11, opacity: 0.75 }}>
                    {item.uf_licenciamento} · {item.proprietario_nome || 'veículo próprio'}
                    {item.ativo === false ? ' · inativo' : ''}
                  </div>
                </div>
              ))
            }
          </div>
        </div>

        <div className={s.painelRight}>
          {modo === 'lista'
            ? <div style={{ color: '#888', fontSize: 12, marginTop: 20, textAlign: 'center' }}>
                🚚 Selecione um veículo ou clique em "+ Veículo".
              </div>
            : (
              <div className={s.form}>
                <div className={s.fieldset}>
                  <div className={s.legend}>{modo === 'novo' ? 'Novo Veículo' : 'Editar Veículo'}</div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo}>
                      <label className={s.label}>Placa *</label>
                      <input className={s.input} value={form.placa} autoFocus maxLength={8}
                        onChange={e => setForm({ ...form, placa: e.target.value.toUpperCase() })} />
                    </div>
                    <div className={s.formGrupo}>
                      <label className={s.label}>UF de licenciamento *</label>
                      <select className={s.select} value={form.uf_licenciamento}
                        onChange={e => setForm({ ...form, uf_licenciamento: e.target.value })}>
                        <option value="">— Selecione —</option>
                        {UFS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
                      </select>
                    </div>
                    <div className={s.formGrupo}>
                      <label className={s.label}>RENAVAM</label>
                      <input className={s.input} value={form.renavam || ''}
                        onChange={e => setForm({ ...form, renavam: e.target.value })} />
                    </div>
                    <div className={s.formGrupo}>
                      <label className={s.label}>Código interno (frota)</label>
                      <input className={s.input} maxLength={10} value={form.codigo_interno || ''}
                        title="Identificador que a própria empresa usa pra esse veículo — vai no MDF-e (<cInt>), opcional"
                        onChange={e => setForm({ ...form, codigo_interno: e.target.value })} />
                    </div>
                  </div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo}>
                      <label className={s.label}>Tipo de rodado</label>
                      <select className={s.select} value={form.tipo_rodado}
                        onChange={e => setForm({ ...form, tipo_rodado: e.target.value })}>
                        {TIPOS_RODADO.map(t => <option key={t.v} value={t.v}>{t.v} — {t.l}</option>)}
                      </select>
                    </div>
                    <div className={s.formGrupo}>
                      <label className={s.label}>Tipo de carroceria</label>
                      <select className={s.select} value={form.tipo_carroceria}
                        onChange={e => setForm({ ...form, tipo_carroceria: e.target.value })}>
                        {TIPOS_CARROCERIA.map(t => <option key={t.v} value={t.v}>{t.v} — {t.l}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo}>
                      <label className={s.label}>Tara (kg)</label>
                      <input className={s.input} type="number" value={form.tara_kg || ''}
                        onChange={e => setForm({ ...form, tara_kg: e.target.value })} />
                    </div>
                    <div className={s.formGrupo}>
                      <label className={s.label}>Capacidade (kg)</label>
                      <input className={s.input} type="number" value={form.capacidade_kg || ''}
                        onChange={e => setForm({ ...form, capacidade_kg: e.target.value })} />
                    </div>
                    <div className={s.formGrupo}>
                      <label className={s.label}>Capacidade (m³)</label>
                      <input className={s.input} type="number" value={form.capacidade_m3 || ''}
                        onChange={e => setForm({ ...form, capacidade_m3: e.target.value })} />
                    </div>
                  </div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo} style={{ flex: 1 }}>
                      <label className={s.label}>Proprietário</label>
                      <select className={s.select} value={form.proprietario_id}
                        onChange={e => setForm({ ...form, proprietario_id: e.target.value })}>
                        <option value="">— Veículo próprio (sem proprietário terceiro) —</option>
                        {proprietarios.map(p => <option key={p.id} value={p.id}>{p.nome} ({p.cpf_cnpj})</option>)}
                      </select>
                    </div>
                  </div>
                  <div className={s.formRow}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
                      <input type="checkbox" checked={!!form.eh_reboque}
                        onChange={e => setForm({ ...form, eh_reboque: e.target.checked })} />
                      Este veículo é reboque/semirreboque (não pode ser escolhido como veículo de tração)
                    </label>
                  </div>
                  {modo === 'editar' && (
                    <div className={s.formRow}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
                        <input type="checkbox" checked={form.ativo !== false}
                          onChange={e => setForm({ ...form, ativo: e.target.checked })} />
                        Ativo
                      </label>
                    </div>
                  )}
                </div>
                <div className={s.rodape} style={{ marginTop: 0, borderTop: 'none', paddingLeft: 0 }}>
                  <button className={s.btnErp} onClick={cancelar}>Cancelar</button>
                  {modo === 'editar' && (
                    <button className={s.btnErp} style={{ color: '#b91c1c' }} onClick={excluir} disabled={excluindo}>
                      {excluindo ? 'Excluindo...' : '🗑 Excluir'}
                    </button>
                  )}
                  <button className={s.btnErpPrimario} onClick={salvar} disabled={salvando}>
                    {salvando ? 'Salvando...' : '✔ Salvar'}
                  </button>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}

// ── Condutores ───────────────────────────────────────────────────────────
function AbaCondutores() {
  const [lista, setLista] = useState([]);
  const [sel, setSel]     = useState(null);
  const [nome, setNome]   = useState('');
  const [cpf, setCpf]     = useState('');
  const [ativo, setAtivo] = useState(true);
  const [modo, setModo]   = useState('lista');
  const [busca, setBusca] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [excluindo, setExcluindo] = useState(false);
  const [erro, setErro]     = useState('');
  const [sucesso, setSucesso] = useState('');

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get('/fiscal/condutores', { params: { busca: busca || undefined, incluirInativos: true } });
      setLista(data || []);
    } catch { setErro('Erro ao carregar condutores.'); }
  }, [busca]);

  useEffect(() => { carregar(); }, [carregar]);

  const novo = () => { setNome(''); setCpf(''); setAtivo(true); setSel(null); setErro(''); setSucesso(''); setModo('novo'); };
  const editar = (item) => { setNome(item.nome); setCpf(formatarCpfCnpj(item.cpf)); setAtivo(item.ativo !== false); setSel(item); setErro(''); setSucesso(''); setModo('editar'); };
  const cancelar = () => { setModo('lista'); setSel(null); setErro(''); };

  const salvar = async () => {
    if (!nome.trim()) { setErro('Nome é obrigatório.'); return; }
    setErro(''); setSalvando(true);
    try {
      const payload = { nome: nome.trim(), cpf, ativo };
      if (modo === 'novo') await api.post('/fiscal/condutores', payload);
      else await api.put(`/fiscal/condutores/${sel.id}`, payload);
      setSucesso('Salvo com sucesso!');
      setTimeout(() => setSucesso(''), 2000);
      await carregar();
      setModo('lista');
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar.');
    } finally { setSalvando(false); }
  };

  const excluir = async () => {
    if (!sel) return;
    if (!window.confirm(`Excluir o condutor "${sel.nome}"?`)) return;
    setErro(''); setExcluindo(true);
    try {
      await api.delete(`/fiscal/condutores/${sel.id}`);
      await carregar();
      setModo('lista'); setSel(null);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao excluir.');
    } finally { setExcluindo(false); }
  };

  return (
    <div>
      <div className={s.toolbar}>
        <button className={s.btnErpPrimario} onClick={novo}>+ Condutor</button>
        <input className={s.input} placeholder="Buscar por nome ou CPF..."
          value={busca} onChange={e => setBusca(e.target.value)} style={{ maxWidth: 220 }} />
      </div>

      {erro    && <div className={s.erroMsg}>{erro}</div>}
      {sucesso && <div className={s.sucessoMsg}>{sucesso}</div>}

      <div className={s.conteudoSplit}>
        <div className={`${s.painel} ${s.painelLeft}`}>
          <div className={s.painelScroll}>
            {lista.length === 0
              ? <div style={{ padding: 16, color: '#888', fontSize: 12 }}>Nenhum condutor cadastrado.</div>
              : lista.map(item => (
                <div key={item.id}
                  className={`${s.listaItem} ${sel?.id === item.id ? s.listaItemSel : ''}`}
                  onClick={() => editar(item)} style={{ opacity: item.ativo === false ? 0.5 : 1 }}>
                  <div style={{ fontWeight: 'bold' }}>{item.nome}</div>
                  <div style={{ fontSize: 11, opacity: 0.75 }}>{formatarCpfCnpj(item.cpf)}{item.ativo === false ? ' · inativo' : ''}</div>
                </div>
              ))
            }
          </div>
        </div>

        <div className={s.painelRight}>
          {modo === 'lista'
            ? <div style={{ color: '#888', fontSize: 12, marginTop: 20, textAlign: 'center' }}>
                🪪 Selecione um condutor ou clique em "+ Condutor".
              </div>
            : (
              <div className={s.form}>
                <div className={s.fieldset}>
                  <div className={s.legend}>{modo === 'novo' ? 'Novo Condutor' : 'Editar Condutor'}</div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo} style={{ flex: 1 }}>
                      <label className={s.label}>Nome *</label>
                      <input className={`${s.input} ${s.inputLarge}`} value={nome} autoFocus
                        onChange={e => setNome(e.target.value)} />
                    </div>
                    <div className={s.formGrupo}>
                      <label className={s.label}>CPF *</label>
                      <input className={s.input} value={cpf} maxLength={14}
                        onChange={e => setCpf(formatarCpfCnpj(e.target.value))} />
                    </div>
                  </div>
                  {modo === 'editar' && (
                    <div className={s.formRow}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
                        <input type="checkbox" checked={ativo} onChange={e => setAtivo(e.target.checked)} />
                        Ativo
                      </label>
                    </div>
                  )}
                </div>
                <div className={s.rodape} style={{ marginTop: 0, borderTop: 'none', paddingLeft: 0 }}>
                  <button className={s.btnErp} onClick={cancelar}>Cancelar</button>
                  {modo === 'editar' && (
                    <button className={s.btnErp} style={{ color: '#b91c1c' }} onClick={excluir} disabled={excluindo}>
                      {excluindo ? 'Excluindo...' : '🗑 Excluir'}
                    </button>
                  )}
                  <button className={s.btnErpPrimario} onClick={salvar} disabled={salvando}>
                    {salvando ? 'Salvando...' : '✔ Salvar'}
                  </button>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}

// ── Proprietários de veículo ─────────────────────────────────────────────
function AbaProprietarios() {
  const vazio = { nome: '', cpf_cnpj: '', ie: '', rntrc: '', tipo_proprietario: 'outros', uf: '' };
  const [lista, setLista] = useState([]);
  const [sel, setSel]     = useState(null);
  const [form, setForm]   = useState(vazio);
  const [modo, setModo]   = useState('lista');
  const [busca, setBusca] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [excluindo, setExcluindo] = useState(false);
  const [erro, setErro]     = useState('');
  const [sucesso, setSucesso] = useState('');

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get('/fiscal/proprietarios-veiculo', { params: { busca: busca || undefined } });
      setLista(data || []);
    } catch { setErro('Erro ao carregar proprietários.'); }
  }, [busca]);

  useEffect(() => { carregar(); }, [carregar]);

  const novo = () => { setForm(vazio); setSel(null); setErro(''); setSucesso(''); setModo('novo'); };
  const editar = (item) => { setForm({ ...vazio, ...item, cpf_cnpj: formatarCpfCnpj(item.cpf_cnpj) }); setSel(item); setErro(''); setSucesso(''); setModo('editar'); };
  const cancelar = () => { setModo('lista'); setSel(null); setErro(''); };

  const salvar = async () => {
    if (!form.nome.trim()) { setErro('Nome é obrigatório.'); return; }
    setErro(''); setSalvando(true);
    try {
      if (modo === 'novo') await api.post('/fiscal/proprietarios-veiculo', form);
      else await api.put(`/fiscal/proprietarios-veiculo/${sel.id}`, form);
      setSucesso('Salvo com sucesso!');
      setTimeout(() => setSucesso(''), 2000);
      await carregar();
      setModo('lista');
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar.');
    } finally { setSalvando(false); }
  };

  const excluir = async () => {
    if (!sel) return;
    if (!window.confirm(`Excluir o proprietário "${sel.nome}"?`)) return;
    setErro(''); setExcluindo(true);
    try {
      await api.delete(`/fiscal/proprietarios-veiculo/${sel.id}`);
      await carregar();
      setModo('lista'); setSel(null);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao excluir.');
    } finally { setExcluindo(false); }
  };

  return (
    <div>
      <div className={s.toolbar}>
        <button className={s.btnErpPrimario} onClick={novo}>+ Proprietário</button>
        <input className={s.input} placeholder="Buscar por nome ou CPF/CNPJ..."
          value={busca} onChange={e => setBusca(e.target.value)} style={{ maxWidth: 220 }} />
      </div>

      {erro    && <div className={s.erroMsg}>{erro}</div>}
      {sucesso && <div className={s.sucessoMsg}>{sucesso}</div>}

      <div className={s.conteudoSplit}>
        <div className={`${s.painel} ${s.painelLeft}`}>
          <div className={s.painelScroll}>
            {lista.length === 0
              ? <div style={{ padding: 16, color: '#888', fontSize: 12 }}>Nenhum proprietário cadastrado.</div>
              : lista.map(item => (
                <div key={item.id}
                  className={`${s.listaItem} ${sel?.id === item.id ? s.listaItemSel : ''}`}
                  onClick={() => editar(item)}>
                  <div style={{ fontWeight: 'bold' }}>{item.nome}</div>
                  <div style={{ fontSize: 11, opacity: 0.75 }}>{formatarCpfCnpj(item.cpf_cnpj)}</div>
                </div>
              ))
            }
          </div>
        </div>

        <div className={s.painelRight}>
          {modo === 'lista'
            ? <div style={{ color: '#888', fontSize: 12, marginTop: 20, textAlign: 'center' }}>
                🏢 Selecione um proprietário ou clique em "+ Proprietário".
              </div>
            : (
              <div className={s.form}>
                <div className={s.fieldset}>
                  <div className={s.legend}>{modo === 'novo' ? 'Novo Proprietário' : 'Editar Proprietário'}</div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo} style={{ flex: 1 }}>
                      <label className={s.label}>Nome/Razão Social *</label>
                      <input className={`${s.input} ${s.inputLarge}`} value={form.nome} autoFocus
                        onChange={e => setForm({ ...form, nome: e.target.value })} />
                    </div>
                  </div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo}>
                      <label className={s.label}>CPF/CNPJ *</label>
                      <input className={s.input} value={form.cpf_cnpj} maxLength={18}
                        onChange={e => setForm({ ...form, cpf_cnpj: formatarCpfCnpj(e.target.value) })} />
                    </div>
                    <div className={s.formGrupo}>
                      <label className={s.label}>IE</label>
                      <input className={s.input} value={form.ie || ''}
                        onChange={e => setForm({ ...form, ie: e.target.value })} placeholder="ISENTO se não contribuinte" />
                    </div>
                    <div className={s.formGrupo}>
                      <label className={s.label}>UF</label>
                      <select className={s.select} value={form.uf || ''}
                        onChange={e => setForm({ ...form, uf: e.target.value })}>
                        <option value="">—</option>
                        {UFS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo}>
                      <label className={s.label}>RNTRC</label>
                      <input className={s.input} value={form.rntrc || ''}
                        onChange={e => setForm({ ...form, rntrc: e.target.value })} />
                    </div>
                    <div className={s.formGrupo} style={{ flex: 1 }}>
                      <label className={s.label}>Tipo</label>
                      <select className={s.select} value={form.tipo_proprietario}
                        onChange={e => setForm({ ...form, tipo_proprietario: e.target.value })}>
                        {TIPOS_PROPRIETARIO.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
                      </select>
                    </div>
                  </div>
                </div>
                <div className={s.rodape} style={{ marginTop: 0, borderTop: 'none', paddingLeft: 0 }}>
                  <button className={s.btnErp} onClick={cancelar}>Cancelar</button>
                  {modo === 'editar' && (
                    <button className={s.btnErp} style={{ color: '#b91c1c' }} onClick={excluir} disabled={excluindo}>
                      {excluindo ? 'Excluindo...' : '🗑 Excluir'}
                    </button>
                  )}
                  <button className={s.btnErpPrimario} onClick={salvar} disabled={salvando}>
                    {salvando ? 'Salvando...' : '✔ Salvar'}
                  </button>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}

const ABAS = [
  { id: 'veiculos',      label: 'Veículos',      icone: '🚚' },
  { id: 'condutores',    label: 'Condutores',    icone: '🪪' },
  { id: 'proprietarios', label: 'Proprietários', icone: '🏢' },
];

export default function CadastrosTransporte() {
  const [aba, setAba] = useState('veiculos');

  return (
    <div className={s.erpWrap}>
      <div className={s.titleBar}><span>🚚</span> Veículos e Condutores (MDF-e)</div>

      <div style={{ display: 'flex', gap: 4, padding: '8px 4px 0', borderBottom: '1px solid var(--border, #e2e8f0)' }}>
        {ABAS.map(a => (
          <button key={a.id}
            onClick={() => setAba(a.id)}
            style={{
              padding: '8px 16px', fontSize: 13, fontWeight: aba === a.id ? 700 : 400,
              background: 'transparent', border: 'none', cursor: 'pointer',
              borderBottom: aba === a.id ? '2px solid #1565c0' : '2px solid transparent',
              color: aba === a.id ? '#1565c0' : 'inherit',
            }}>
            {a.icone} {a.label}
          </button>
        ))}
      </div>

      <div style={{ marginTop: 8 }}>
        {aba === 'veiculos'      && <AbaVeiculos />}
        {aba === 'condutores'    && <AbaCondutores />}
        {aba === 'proprietarios' && <AbaProprietarios />}
      </div>
    </div>
  );
}
